export const ProductSpecificationKeys = [
    "specification.benefits",
    "specification.specs",
] as const;